module.exports = __webpack_public_path__ + "img/android_icon.e45bc817.svg";